
const SLUG_PREFIX_REGEX = '^\\/[a-z0-9]+(?:-[a-z0-9]+)*\\/[a-z0-9]+(?:-[a-z0-9]+)*\\/';

export const shouldPreventSearchesOnSubViews = (currentPage, lastURL) => {
  const pathName = new URL(currentPage.url).pathname;
  const basePathName = pathName.match(SLUG_PREFIX_REGEX)?.[0];

  return lastURL?.includes(basePathName) && currentPage.url?.includes(basePathName);
};
